import React from "react";
import {Button, Toast} from "spectre-react/dist/cjs";
import PropTypes from "prop-types";


const ErrorToast = ({children, onButtonClick, ...rest}) => {
    return (
        <Toast {...rest} error>
            {onButtonClick && <Button className="btn-clear float-right" onClick={onButtonClick}></Button>}
            {children}
        </Toast>
    )
}

ErrorToast.propTypes = {
    children: PropTypes.node.isRequired,
    onButtonClick: PropTypes.func,
}

export default ErrorToast;